import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-slot",
  "use": "svgIcon-slot-usage",
  "viewBox": "3.714 3 491.484 661.701",
  "content": "<symbol viewBox=\"3.714 3 491.484 661.701\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-slot\"><path d=\"m447.198 451v165.701h-395.484v-165.701zm48-28h-491.484v242.701h491.484z\" fill=\"currentColor\" /><path d=\"m447.198 246v176.703h-395.484v-176.703zm48-28h-491.484v233.703h491.484z\" fill=\"currentColor\" /><path d=\"m447.198 51v166.702h-395.484v-166.702zm48-48h-491.484v242.702h491.484z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol